import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

export default function useOccupations() {
  const [occupations, setOccupations] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  const getOccupationName = (id) => {
    const foundOccupation = occupations.find((occ) => occ.id === id);
    if (foundOccupation) return foundOccupation.name;
    else return "";
  };

  const getOccupationfromId = (id) => {
    // alert(id);

    return occupations.find((occ) => occ.id === id);
  };

  useEffect(() => {
    dataProvider
      .getList("occupations", {})
      .then(({ data }) => {
        setOccupations(data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    occupations,
    loading,
    error,
    getOccupationName,
    getOccupationfromId,
  };
}
